import request from '../../library/request';
import setGlobalState from '../setGlobalState';
import {getState} from '../store.type';

export const getPromotionMessages = async () => {
    const res = await request('promotion.getPromotionMessages', 'get', '/promotionMessages');
    if(res?.messages)
        setGlobalState('promotion.promotionMessages', res.messages);
};
export const updateMessage = async (pmid, update) => {
    const res = await request('promotion.updatePromotionMessages', 'put', `/promotionMessages/${pmid}`, {update});
    if(res?.messages)
        setGlobalState('promotion.promotionMessages', res.messages);
};

export const getRelevantEventsByType = async(pmid) => {
    const messageIndex = getState().promotion.promotionMessages?.findIndex((m: any)=> m.pmid === pmid);
    const res = await request('promotion.getRelevantEventsByType', 'get', '/promotionRelevantEvents', {pmid});
    setGlobalState(`promotion.promotionMessages[${messageIndex}].eventList`, res?.events || []);
};
